import {create} from 'zustand';
import {getMerchantProfile, updateMerchantProfile} from "../network/api";
import {getCookie} from "../utils";

const merchantStore = create((set) => ({
    merchantProfile: null,
    getMerchantProfile: async () => {
        const response = await getMerchantProfile();
        let profile = null
        if (response.success) {
            const tokenShare = getCookie('token-share');
            if (tokenShare) document.cookie = `token-share=; path=/; domain=funong.vn; expires=Thu, 01 Jan 1970 00:00:00 UTC; secure; SameSite=None`;
            profile = response.data
        }
        set({merchantProfile: profile});
        return response;
    },
    updateMerchantProfile: async (params) => {
        return await updateMerchantProfile(params);
    },
}));

export default merchantStore;
